import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import GradeHeader from './components/GradeHeader';
import WeeksTable from './components/WeeksTable';
import { ModuleProps } from 'types';
import useKeyLessonPreview from '../hooks/use-key-lesson-preview';
import PreviewListContainer from '../components/PreviewListContainer';

const useStyles = makeStyles((theme: Theme) => {
  return {
    headerContainer: {
      padding: theme.spacing(4),
      paddingBottom: theme.spacing(1)
    }
  };
});

const WeeksLessonPreview: React.FC<ModuleProps> = props => {
  const classes = useStyles();
  const { data, gradeLevel } = useKeyLessonPreview();

  return (
    <PreviewListContainer {...props}>
      <div className={classes.headerContainer}>
        <GradeHeader gradeLevel={gradeLevel} />
      </div>
      <WeeksTable data={data as any} />
    </PreviewListContainer>
  );
};

export default WeeksLessonPreview;
